var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'disabled': _vm.disabled
  },on:{"click":_vm.clicked}},[_c('p4a-icon',{staticClass:"svg-image",class:{
      'disabled': _vm.disabled
    },style:({
      'transform': 'rotate(' + _vm.rotation + 'turn)'
    }),attrs:{"color":_vm.color,"icon":_vm.icon}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f6bba01","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/pro4all-ui/sns-components/kit-components/buttontemplates/IconButton.vue
// module id = null
// module chunks = 